import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import Live from "./live/live"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/live`}>
        <Live />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
